/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

import CourseFlow from "./components/CourseFlow";

require('bootstrap');
require('../../node_modules/bootstrap-select/dist/js/bootstrap-select');
var Flickity = require('flickity');
import SVGInjector from 'svg-injector';
import mixitup from 'mixitup';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

const selJQuery = require("jquery");

(function ($) {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Starter = {
        // All pages
        'common': {

            init: function () {
                document.querySelectorAll('[data-subscribe]').forEach((el) => new CourseFlow(el));

                var mySVGsToInject = document.querySelectorAll('img.inject');
                new SVGInjector(mySVGsToInject);

                const tooltips = document.querySelectorAll('[data-tooltip]');
                if (tooltips.length > 0) {
                    tooltips.forEach((element) => {
                        const tooltip = element.dataset.tooltip;
                        console.log(element);
                        tippy(element, {
                            content: tooltip,
                            trigger: 'click',
                        });
                    })
                }

                $("body").css("padding-top", function () {
                    return $('.block--nav').height();
                });

                $('.nav__hamburger').on('click', function () {
                    if ($(window).width() < 1200) {
                        $.scrollLock();
                    }
                    $(this).toggleClass("is-active");
                    const navWrapper = $('.nav__wrapper');
                    if (navWrapper.hasClass('toggle')) {
                        navWrapper.removeClass("toggle");
                    } else {
                        navWrapper.addClass("toggle");
                    }
                });

                $(document).on('mouseover', '.menu-item-has-children a', function () {
                    if ($(window).width() < 1200) {
                        $.scrollLock();
                    }
                    $(this).toggleClass("is-active");
                    $('.sub-menu').addClass("toggle");
                });

                window.addEventListener('mouseup', function () {
                    $('.sub-menu').removeClass("toggle");
                });

                // Carousel
                if ($('.carousel--images').length > 0) {
                    new Flickity('.carousel--images', {
                        cellAlign: 'center',
                        contain: true,
                        pageDots: false,
                        prevNextButtons: true,
                        lazyLoad: 2
                    });
                }

                if ($('.reviews__slider').length > 0) {
                    new Flickity('.reviews__slider', {
                        cellAlign: 'center',
                        contain: true,
                        pageDots: true,
                        prevNextButtons: true,
                        wrapAround: true,
                    });
                }

                if ($('.carousel--catering').length > 0) {
                    new Flickity('.carousel--catering', {
                        cellAlign: 'center',
                        contain: true,
                        pageDots: false,
                        prevNextButtons: true,
                        lazyLoad: 2
                    });
                }


                if ($('.carousel--team').length > 0) {
                    if ($(window).width() < 767) {
                        new Flickity('.carousel--team', {
                            cellAlign: 'left',
                            contain: true,
                            pageDots: false,
                            prevNextButtons: false,
                            groupCells: true
                        });
                    }
                }

                if ($('.block--coursemoments-carousel').length > 0) {
                    const coursemomentsFlkty = new Flickity('.block--coursemoments-carousel', {
                        cellAlign: 'center',
                        contain: true,
                        pageDots: false,
                        prevNextButtons: false,
                        wrapAround: true
                    });
                    $('.block--coursemoments-carousel__next').on('click', function () {
                        coursemomentsFlkty.next();
                    });
                    $('.block--coursemoments-carousel__prev').on('click', function () {
                        coursemomentsFlkty.previous();
                    });
                }
                // Einde carousel


                // Modal teammember
                $('#modal--teammember').on('show.bs.modal', function (event) {
                    var button = $(event.relatedTarget)
                    var teammemberbio = button.data('teammemberbio')
                    var teammembertitle = button.data('teammembertitle')
                    var teammemberimg = button.data('teammemberimg')
                    var teammemberimgalt = button.data('teammemberimg-alt')

                    var modal = $(this)

                    modal.find('.teammodal__info h2').html(teammembertitle);
                    modal.find('.teammodal__info div').html(teammemberbio);

                    modal.find('.teammodal__img-wrapper img').attr("src", teammemberimg);
                    modal.find('.teammodal__img-wrapper img').attr("alt", teammemberimgalt);
                })
                // Einde modal teammember


                // Popovers
                let popTrigger = 'click';
                if ($(window).width() > 1024) {
                    popTrigger = 'hover';
                }

                $("[data-toggle=popover]").popover({
                    html: true,
                    trigger: popTrigger,
                    content: function () {
                        return $(this).next('#popover-content').html();
                    }
                });

                if ($('.modal--addedcourse')) {
                    setTimeout(function () {
                        $('.modal--addedcourse').modal('show');
                    }, 1000);
                }

                // Selectpicker
                $(document).on('gform_post_render', function () {
                    $('.gform_wrapper .gfield_select').addClass('selectpicker');
                    $('.form--subscribe .form-select').addClass('selectpicker');
                    selJQuery('.selectpicker').selectpicker({})
                });
                // Einde selectpicker

                // Parsley

                // // Validation errors messages for Parsley
                // // Load this after Parsley
                Parsley.addMessages('nl', {
                    defaultMessage: "Deze waarde lijkt onjuist.",
                    type: {
                        email: "Dit lijkt geen geldig e-mailadres te zijn.",
                        url: "Dit lijkt geen geldige URL te zijn.",
                        number: "Deze waarde moet een nummer zijn.",
                        integer: "Deze waarde moet een nummer zijn.",
                        digits: "Deze waarde moet numeriek zijn.",
                        alphanum: "Deze waarde moet alfanumeriek zijn."
                    },
                    notblank: "Deze waarde mag niet leeg zijn.",
                    required: "Dit veld is verplicht.",
                    pattern: "Deze waarde lijkt onjuist te zijn.",
                    min: "Deze waarde mag niet lager zijn dan %s.",
                    max: "Deze waarde mag niet groter zijn dan %s.",
                    range: "Deze waarde moet tussen %s en %s liggen.",
                    minlength: "Deze tekst is te kort. Deze moet uit minimaal %s karakters bestaan.",
                    maxlength: "Deze waarde is te lang. Deze mag maximaal %s karakters lang zijn.",
                    length: "Deze waarde moet tussen %s en %s karakters lang zijn.",
                    equalto: "Deze waardes moeten identiek zijn."
                });

                Parsley.setLocale('nl');

                Parsley.addMessages('nl', {
                    dateiso: "Deze waarde moet een datum in het volgende formaat zijn: (YYYY-MM-DD).",
                    minwords: "Deze waarde moet minstens %s woorden bevatten.",
                    maxwords: "Deze waarde mag maximaal %s woorden bevatten.",
                    words: "Deze waarde moet tussen de %s en %s woorden bevatten.",
                    gt: "Deze waarde moet groter dan %s zijn.",
                    lt: "Deze waarde moet kleiner dan %s zijn."
                });
                // Einde Parsley

                if ($(window).width() < 767) {
                    function setupReadMore($elements, $more, startSize) {
                        var elementSize = $elements.size(),
                            totalSize = startSize;

                        $elements.slice(0, startSize).show();

                        $more.find('a').on('click', function (e) {
                            totalSize = elementSize;
                            $elements.slice(0, totalSize).show();

                            if (totalSize === elementSize) {
                                $more.remove();
                            }

                            e.preventDefault();
                        });
                    }

                    setupReadMore($('.programme__li'), $('.buttons--fullprogramme'), 5);
                }


                // Modal program
                $('#modal--programme').on('show.bs.modal', function (event) {
                    var button = $(event.relatedTarget)
                    var programmestarttime = button.data('programmestarttime')
                    var programmeendtime = button.data('programmeendtime')
                    var programmetitle = button.data('programmetitle')
                    var programmetext = button.data('programmetext')

                    var modal = $(this)

                    modal.find('.programmemodal__info .programme__time--start').html(programmestarttime);
                    modal.find('.programmemodal__info .programme__time--end').html('&nbsptot ' + programmeendtime);
                    modal.find('.programmemodal__info h2').html(programmetitle);
                    modal.find('.programmemodal__info div').html(programmetext);
                })
                // End modal program

                $(document).on('click', '[data-role="expand-button"]', (e) => {
                    const elm = e.target;
                    const li = elm.closest('li');
                    const detail = li.querySelector('.programme__li--details');

                    detail.classList.toggle('programme__li--details--open');
                });
            }
        },

        'page_template_template_form': {
            init: function () {

                var $datepicker = $('.datepicker');

                if ($datepicker.length) {

                    // Datepicker
                    function noSundaysOrSaturdays(date) {
                        var weekday = new Array(7);
                        weekday[0] = "Sunday";
                        weekday[1] = "Monday";
                        weekday[2] = "Tuesday";
                        weekday[3] = "Wednesday";
                        weekday[4] = "Thursday";
                        weekday[5] = "Friday";
                        weekday[6] = "Saturday";
                        //console.log(weekday[date.getDay()]);
                        if (weekday[date.getDay()] == 'Sunday') {
                            return [false, '', 'Not open on Sundays'];
                        } else if (weekday[date.getDay()] == 'Saturday') {
                            return [false, '', 'Not open on Saturdays'];
                        }

                        return [true];
                    }


                    $datepicker.datepicker({
                        dayNamesMin: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
                        monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
                        monthNames: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
                        firstDay: 1,
                        minDate: "+1d",
                        beforeShowDay: $.datepicker.noWeekends,
                        dateFormat: 'dd-mm-yy'
                    });
                };


                //Einde datepicker


            },
            finalize: function () {

            }
        },

        'symposium_template_default': {
            init: function () {


            }
        },

        'page_template_template_teachers': {
            init: function () {

                var $filterContainer = $('.filter__form');
                var $teachersContainer = $('.team');

                var mixer = mixitup($teachersContainer, {
                    controls: {
                        toggleDefault: 'none'
                    },
                    selectors: {
                        control: '[data-mixitup-control]'
                    },
                    callbacks: {
                        onMixEnd: function (state) {
                            var $nofilterResults = $('#no-filter-results');

                            if (state.totalMatching == '0') {
                                if (!$nofilterResults.hasClass('visible')) {
                                    $nofilterResults.addClass('visible');
                                }
                            } else {
                                $nofilterResults.removeClass('visible');
                            }
                        }
                    }

                });

                $filterContainer.on("submit", function (evt) {
                    var $form = $(evt.target);
                    evt.preventDefault();

                    var filterData = {};

                    $($form.serializeArray()).each(function (index, obj) {
                        filterData[obj.name] = obj.value;
                    });

                    mixer.filter($teachersContainer.children().filter(function (index, el) {
                        var $el = $(el);
                        var elData = $el.data();
                        var include = true;

                        if (filterData.q) {
                            include = include && ($el.text().toString().toLowerCase().indexOf(filterData.q.toString().toLowerCase()) > -1);
                            if (elData.functie) {
                                include = include || (elData.functie.toString().toLowerCase().indexOf(filterData.q.toString().toLowerCase()) > -1);
                            }
                            if (elData.categories) {
                                include = include || (elData.categories.toString().toLowerCase().indexOf(filterData.q.toString().toLowerCase()) > -1);
                            }
                            if (elData.group) {
                                include = include || (elData.group.toString().toLowerCase().indexOf(filterData.q.toString().toLowerCase()) > -1);
                            }
                        }
                        return include;
                    }));

                });

                var prevFilled = false;

                $filterContainer.find('[name=q]').each(function (index, elm) {
                    if ($(elm).val() != '') {
                        prevFilled = true;
                    }
                });

                if (prevFilled) {
                    $filterContainer.submit();
                }

                $filterContainer.on('change', function (evt, ui) {
                    $filterContainer.submit();
                });

                $filterContainer.find('input').on('keyup', function (evt) {
                    if ($(this).val().length > 2) {
                        $filterContainer.submit();
                    }
                    if ($(this).val().length == 0) {
                        $filterContainer.submit();
                    }
                });


            }
        },

        'page_template_template_acta_talks': {
            init: function () {

                var $filterContainer = $('.filter__form');
                var $talksContainer = $('.team');

                var mixer = mixitup($talksContainer, {
                    controls: {
                        toggleDefault: 'none'
                    },
                    callbacks: {
                        onMixEnd: function (state) {
                            var $nofilterResults = $('#no-filter-results');

                            if (state.totalMatching == '0') {
                                if (!$nofilterResults.hasClass('visible')) {
                                    $nofilterResults.addClass('visible');
                                }
                            } else {
                                $nofilterResults.removeClass('visible');
                            }
                        }
                    }

                });

                $filterContainer.on("submit", function (evt) {
                    var $form = $(evt.target);
                    evt.preventDefault();

                    var filterData = {};

                    $($form.serializeArray()).each(function (index, obj) {
                        filterData[obj.name] = obj.value;
                    });

                    mixer.filter($talksContainer.children().filter(function (index, el) {
                        var $el = $(el);
                        var elData = $el.data();
                        var include = true;

                        if (filterData.q) {
                            include = $el.text().toString().toLowerCase().indexOf(filterData.q.toString().toLowerCase()) > -1;
                            if (elData.functie) {
                                include = include || (elData.functie.toString().toLowerCase().indexOf(filterData.q.toString().toLowerCase()) > -1);
                            }
                        }

                        return include;
                    }));

                });

                var prevFilled = false;

                $filterContainer.find('[name=q]').each(function (index, elm) {
                    if ($(elm).val() != '') {
                        prevFilled = true;
                    }
                });

                if (prevFilled) {
                    $filterContainer.submit();
                }

                $filterContainer.on('change', function (evt, ui) {
                    $filterContainer.submit();
                });

                $filterContainer.find('input').on('keyup', function (evt) {
                    if ($(this).val().length > 2) {
                        $filterContainer.submit();
                    }
                    if ($(this).val().length == 0) {
                        $filterContainer.submit();
                    }
                });

            }
        },


        'page_template_template_courses': {
            init: function () {


                // Filter
                var $filterContainer = $('.filter__form');
                var $coursesContainer = $('.courses__courses');
                var $sortSelect = $('#sortselect');

                var mixer = mixitup($coursesContainer, {
                    controls: {
                        toggleDefault: 'none'
                    },
                    callbacks: {
                        onMixEnd: function (state) {
                            $('#course-count').text(state.totalMatching);

                            var $nofilterResults = $('#no-filter-results');

                            if (state.totalMatching == '0') {
                                if (!$nofilterResults.hasClass('visible')) {
                                    $nofilterResults.addClass('visible');
                                }
                            } else {
                                $nofilterResults.removeClass('visible');
                            }

                        }
                    }
                });


                var currentSelect = '';
                $filterContainer.on('click', '.choices input', function () {
                    if (currentSelect !== this) {
                        currentSelect = this;
                    } else {
                        currentSelect = '';
                        $(this).prop('checked', false);
                        $(this).trigger('change');
                    }
                });


                /*
                $('.js-reset-filter').on('click', function(){
                    $('.filter input').prop('checked', false);
                });
                */
                $("button[type='reset']").on("click", function (evt) {
                    var $form = $(evt.target).closest('form');

                    evt.preventDefault();

                    $form.get(0).reset();
                    // $form.find('select').val('');
                    //$form.find('select.selectpicker').selectpicker('refresh');

                });


                $('#sortselect').on('change', function () {
                    var sortValue = $(this).val();

                    mixer.sort(sortValue);
                });
                $('#sortselect').trigger('change');

                $filterContainer.on("submit", function (evt) {

                    var $form = $(evt.target);

                    evt.preventDefault();

                    console.trace("submit handler");

                    $('#modal--filter').modal('hide');

                    var filterData = {};

                    $($form.serializeArray()).each(function (index, obj) {
                        filterData[obj.name] = obj.value;
                    });



                    mixer.filter($coursesContainer.children().filter(function (index, el) {
                        var $el = $(el);
                        var elData = $el.data();

                        var include = true;

                        if (filterData.q) {
                            include = include && ($el.text().toString().toLowerCase().indexOf(filterData.q.toString().toLowerCase()) > -1);
                        }

                        if (filterData.who && elData.who) {
                            include = include && (elData.who.indexOf(filterData.who) > -1);
                        }

                        if (filterData.discipline && elData.discipline) {
                            include = include && (elData.discipline.indexOf(filterData.discipline) > -1);
                        }

                        if (filterData.date) {
                            include = include && (elData.date == filterData.date);
                        }

                        if (filterData.krt) {
                            switch (filterData.krt) {
                                case '0-3':
                                    include = include && (elData.krt <= 3);
                                    break;
                                case '4-6':
                                    include = include && (elData.krt > 3 && elData.krt <= 6);
                                    break;
                                case '7+':
                                    include = include && (elData.krt >= 7);
                                    break;
                            }
                        }

                        if (filterData.krm) {
                            switch (filterData.krm) {
                                case '0-3':
                                    include = include && (elData.krm <= 3);
                                    break;
                                case '4-6':
                                    include = include && (elData.krm > 3 && elData.krm <= 6);
                                    break;
                                case '7+':
                                    include = include && (elData.krm >= 7);
                                    break;
                            }
                        }

                        if (filterData.mouthcarepoints) {
                            switch (filterData.mouthcarepoints) {
                                case '0-3':
                                    include = include && (elData.mouthcarepoints <= 3);
                                    break;
                                case '4-6':
                                    include = include && (elData.mouthcarepoints > 3 && elData.mouthcarepoints <= 6);
                                    break;
                                case '7+':
                                    include = include && (elData.mouthcarepoints >= 7);
                                    break;
                            }
                        }

                        if (filterData.length) {
                            switch (filterData.length) {
                                case '1 dag':
                                    include = include && (elData.length == '1day');
                                    break;
                                case '2 - 3 dagen':
                                    include = include && (elData.length == '2-3days');
                                    break;
                                case '3 dagen +':
                                    include = include && (elData.length == '4moredays');
                                    break;
                            }
                        }

                        if (filterData.price) {
                            switch (filterData.price) {
                                case '500':
                                    include = include && (elData.price <= 500);
                                    break;
                                case '1000':
                                    include = include && (elData.price <= 1000);
                                    break;
                                case '2000':
                                    include = include && (elData.price <= 2000);
                                    break;
                                case '3000':
                                    include = include && (elData.price <= 3000);
                                    break;
                            }
                        }


                        return include;
                    }));

                });

                setTimeout(() => {
                    var prevFilled = false;

                    $filterContainer.find('[name=who], [name=discipline], [name=q]').each(function (index, elm) {
                        if ($(elm).val() != '') {
                            prevFilled = true;
                        }
                    });

                    const formData = new FormData($filterContainer[0]);
                    for (const pair of formData.entries()) {
                        console.log(`${pair[0]}, ${pair[1]}`);
                        if(pair[0]){
                            prevFilled = true;
                        }
                    }
                    console.log(new URLSearchParams(formData).toString());

                    if (prevFilled) {
                        $filterContainer.submit();
                    }

                    $filterContainer.on('change', function (evt, ui) {

                        if ($(evt.target).closest('.modal').length == 0) {
                            $filterContainer.submit();
                        }

                    });

                }, 500);


                // Einde filter

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },

        'page_template_template_contact': {
            init: function () {

                /*
                *  new_map
                *
                *  This function will render a Google Map onto the selected jQuery element
                *
                *  @type    function
                *  @date    8/11/2013
                *  @since   4.3.0
                *
                *  @param   $el (jQuery element)
                *  @return  n/a
                */

                function new_map($el) {

                    var $markers = $el.find('.marker');

                    var args = {
                        zoom: 16,
                        center: new google.maps.LatLng(0, 0),
                        mapId: "CONTACT_MAP", // set map id because AdvancedMarkerElement needs it
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        disableDefaultUI: true,
                        scrollwheel: false,
                        // draggable               : false,
                        zoomControl: false,
                        disableDoubleClickZoom: false,
                        // disabled because maps with mapId can't have styles
                        // styles: [
                        //     {
                        //         "featureType": "landscape",
                        //         "elementType": "geometry",
                        //         "stylers": [
                        //             {
                        //                 "hue": "#f3f4f4"
                        //             },
                        //             {
                        //                 "saturation": -84
                        //             },
                        //             {
                        //                 "lightness": 59
                        //             },
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "landscape",
                        //         "elementType": "labels",
                        //         "stylers": [
                        //             {
                        //                 "hue": "#ffffff"
                        //             },
                        //             {
                        //                 "saturation": -100
                        //             },
                        //             {
                        //                 "lightness": 100
                        //             },
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "poi.attraction",
                        //         "elementType": "labels.text",
                        //         "stylers": [
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "poi.business",
                        //         "elementType": "labels.icon",
                        //         "stylers": [
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "poi.government",
                        //         "elementType": "labels.text",
                        //         "stylers": [
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "poi.medical",
                        //         "elementType": "labels.text",
                        //         "stylers": [
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "poi.park",
                        //         "elementType": "geometry",
                        //         "stylers": [
                        //             {
                        //                 "hue": "#00ff8f"
                        //             },
                        //             {
                        //                 "saturation": 1
                        //             },
                        //             {
                        //                 "lightness": -15
                        //             },
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "poi.place_of_worship",
                        //         "elementType": "labels.text",
                        //         "stylers": [
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "poi.school",
                        //         "elementType": "all",
                        //         "stylers": [
                        //             {
                        //                 "hue": "#d7e4e4"
                        //             },
                        //             {
                        //                 "saturation": -60
                        //             },
                        //             {
                        //                 "lightness": 23
                        //             },
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "poi.school",
                        //         "elementType": "labels.text",
                        //         "stylers": [
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "road",
                        //         "elementType": "geometry",
                        //         "stylers": [
                        //             {
                        //                 "hue": "#ffffff"
                        //             },
                        //             {
                        //                 "saturation": -100
                        //             },
                        //             {
                        //                 "lightness": 100
                        //             },
                        //             {
                        //                 "visibility": "on"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "road",
                        //         "elementType": "labels",
                        //         "stylers": [
                        //             {
                        //                 "hue": "#bbbbbb"
                        //             },
                        //             {
                        //                 "saturation": -100
                        //             },
                        //             {
                        //                 "lightness": 26
                        //             },
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "road.highway",
                        //         "elementType": "geometry",
                        //         "stylers": [
                        //             {
                        //                 "hue": "#ffcc00"
                        //             },
                        //             {
                        //                 "saturation": 100
                        //             },
                        //             {
                        //                 "lightness": -22
                        //             },
                        //             {
                        //                 "visibility": "on"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "road.arterial",
                        //         "elementType": "geometry",
                        //         "stylers": [
                        //             {
                        //                 "hue": "#ffcc00"
                        //             },
                        //             {
                        //                 "saturation": 100
                        //             },
                        //             {
                        //                 "lightness": -35
                        //             },
                        //             {
                        //                 "visibility": "simplified"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "water",
                        //         "elementType": "all",
                        //         "stylers": [
                        //             {
                        //                 "hue": "#7fc8ed"
                        //             },
                        //             {
                        //                 "saturation": 55
                        //             },
                        //             {
                        //                 "lightness": -6
                        //             },
                        //             {
                        //                 "visibility": "on"
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         "featureType": "water",
                        //         "elementType": "labels",
                        //         "stylers": [
                        //             {
                        //                 "hue": "#7fc8ed"
                        //             },
                        //             {
                        //                 "saturation": 55
                        //             },
                        //             {
                        //                 "lightness": -6
                        //             },
                        //             {
                        //                 "visibility": "off"
                        //             }
                        //         ]
                        //     }
                        // ]
                    };


                    // create map
                    var map = new google.maps.Map($el[0], args);


                    // add a markers reference
                    map.markers = [];


                    // add markers
                    $markers.each(function () {

                        add_marker($(this), map);

                    });


                    // center map
                    center_map(map);


                    // return
                    return map;

                }

                /*
                *  add_marker
                *
                *  This function will add a marker to the selected Google Map
                *
                *  @type    function
                *  @date    8/11/2013
                *  @since   4.3.0
                *
                *  @param   $marker (jQuery element)
                *  @param   map (Google Map object)
                *  @return  n/a
                */

                function add_marker($marker, map) {

                    const position = new google.maps.LatLngAltitude({
                        lat: $marker.data('lat'),
                        lng: $marker.data('lng'),
                    });
                    const iconBase = '../../app/themes/actadental/dist/images/';

                    if ($(window).width() < 992) {
                        var markerWidth = 24;
                        var markerHeight = 37;
                    } else {
                        var markerWidth = 36;
                        var markerHeight = 55;
                    }

                    const content = document.createElement("img");
                    content.src = iconBase + 'map-pin.svg';
                    content.width = markerWidth;
                    content.height = markerHeight;

                    //changed marker api because of google maps warning
                    var marker = new google.maps.marker.AdvancedMarkerElement({
                        position,
                        map,
                        content,
                    });

                    // add to array
                    map.markers.push(marker);

                    // if marker contains HTML, add it to an infoWindow
                    if ($marker.html()) {

                        const infowindow = new google.maps.InfoWindow({
                            content: $marker.html(),
                            ariaLabel: "Contact informatie",
                        });

                        google.maps.event.addListener(marker, 'click', function () {
                            infowindow.open(map, marker);
                        });
                        google.maps.event.addListener(map, 'click', function () {
                            infowindow.close(map, marker);
                        });

                    }

                }

                /*
                *  center_map
                *
                *  This function will center the map, showing all markers attached to this map
                *
                *  @type    function
                *  @date    8/11/2013
                *  @since   4.3.0
                *
                *  @param   map (Google Map object)
                *  @return  n/a
                */

                function center_map(map) {

                    // vars
                    var bounds = new google.maps.LatLngBounds();

                    // loop through all markers and create bounds
                    $.each(map.markers, function (i, marker) {

                        var latlng = new google.maps.LatLng(marker.position.lat, marker.position.lng);

                        bounds.extend(latlng);

                    });

                    // only 1 marker?
                    if (map.markers.length == 1) {
                        // set center of map
                        map.setCenter(bounds.getCenter());
                        map.setZoom(16);
                    }
                    else {
                        // fit to bounds
                        map.fitBounds(bounds);
                    }

                }

                /*
                *  document ready
                *
                *  This function will render each map when the document is ready (page has loaded)
                *
                *  @type    function
                *  @date    8/11/2013
                *  @since   5.0.0
                *
                *  @param   n/a
                *  @return  n/a
                */
                // global var
                var map = null;


                $(document).ready(function () {

                    var interval = setInterval(function () {
                        if (window.google) {
                            clearInterval(interval);
                            $('.acf-map').each(function () {

                                // create map
                                map = new_map($(this));

                            });

                        }
                    }, 100);



                });



            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        }

    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Starter;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
